module.exports = __webpack_public_path__ + "img/EXTRACTOS.e26cb482.png";